module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (234).17d51485.jpg";